// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add styles here only for things Tamagui doesn't support. Ideally very few
   things go here, but stuff like keyframe CSS animations that Tamagui doesn't
   support can be added here. Be sure to try \`\$platform-web\` style prop first as
   that should avoid needing to add here.  */

.text-wrap-pretty {
  text-wrap: pretty;
}

.text-decoration-none {
  text-decoration: none;
}

@media screen and (max-width: 864px) {
  /* the :root:root:root is to have higher specificity than tamagui */
  :root:root:root .connect-with-us-layout {
    display: flex;
    flex-direction: column;
  }
}

@keyframes token-float-animation {
  0% {
    transform: translateY(-8px);
  }
  50% {
    transform: translateY(8px);
  }
  100% {
    transform: translateY(-8px);
  }
}

@keyframes token-rotate-animation {
  0% {
    transform: rotate(-22deg);
  }
  100% {
    transform: rotate(22deg);
  }
}

.scrollbar-hidden {
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.last-child-flex-end {
  &:last-child {
    justify-content: flex-end;
  }
}
.first-child-flex-grow-0 {
  &:first-child {
    flex-grow: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA;;;4CAG4C;;AAE5C;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mEAAmE;EACnE;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["/* Add styles here only for things Tamagui doesn't support. Ideally very few\n   things go here, but stuff like keyframe CSS animations that Tamagui doesn't\n   support can be added here. Be sure to try `$platform-web` style prop first as\n   that should avoid needing to add here.  */\n\n.text-wrap-pretty {\n  text-wrap: pretty;\n}\n\n.text-decoration-none {\n  text-decoration: none;\n}\n\n@media screen and (max-width: 864px) {\n  /* the :root:root:root is to have higher specificity than tamagui */\n  :root:root:root .connect-with-us-layout {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n@keyframes token-float-animation {\n  0% {\n    transform: translateY(-8px);\n  }\n  50% {\n    transform: translateY(8px);\n  }\n  100% {\n    transform: translateY(-8px);\n  }\n}\n\n@keyframes token-rotate-animation {\n  0% {\n    transform: rotate(-22deg);\n  }\n  100% {\n    transform: rotate(22deg);\n  }\n}\n\n.scrollbar-hidden {\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.last-child-flex-end {\n  &:last-child {\n    justify-content: flex-end;\n  }\n}\n.first-child-flex-grow-0 {\n  &:first-child {\n    flex-grow: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
